import { render, staticRenderFns } from "./mendian.vue?vue&type=template&id=6dd820eb&"
import script from "./mendian.vue?vue&type=script&lang=js&"
export * from "./mendian.vue?vue&type=script&lang=js&"
import style0 from "./mendian.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports